/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {makeLocaleStaticProps} from 'web_core/utils/static_props';
import {DefaultLayout} from '~/components/Layout/Default';
export const getStaticProps = makeLocaleStaticProps;
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    h2: "h2",
    h3: "h3",
    ul: "ul",
    li: "li",
    h4: "h4"
  }, props.components);
  return _jsxs(DefaultLayout, {
    head: {
      title: `コミュニティガイドライン`,
      description: "利用者の皆様が快適に Mathlog をご利用頂けるように、以下に示すコミュニティガイドラインに沿った利用をお願いします。コミュニティガイドラインに沿っていない利用者様に関しては、悪質な場合、運営の判断で警告、機能の制限、アカウントの停止を行うことがあります。"
    },
    maxWidth: 1000,
    children: [_jsx("h1", {
      className: "fs-3",
      children: "コミュニティガイドライン"
    }), _jsxs("div", {
      className: "mathdown-colorful",
      children: [_jsx(_components.p, {
        children: "利用者の皆様が快適に Mathlog をご利用頂けるように、以下に示すコミュニティガイドラインに沿った利用をお願いします。コミュニティガイドラインに沿っていない利用者様に関しては、悪質な場合、運営の判断で警告、機能の制限、アカウントの停止を行うことがあります。"
      }), _jsx(_components.h2, {
        children: "Mathlog の哲学"
      }), _jsx(_components.p, {
        children: "Mathlog は「数学の魅力の共有と発見」と「アウトプットとフィードバックを通じた学び」の 2 つを大切に運営をしております。以下では、それぞれについて詳しく説明します。"
      }), _jsx(_components.h3, {
        children: "数学の魅力の共有と発見"
      }), _jsx(_components.p, {
        children: "数学には実に様々な魅力があり、1 つの数学的事実でも見方を変えると、異なる魅力に気づくこともあるでしょう。Mathlog では、それぞれのユーザが気づいた数学の魅力を共有することを大事にしております。例えば、自分が見つけた興味深い公式とその証明の紹介、論文や数学書を読んで気づいた興味深い内容の紹介、よく知られた事実に対する自分なりの考え方、数学史上有名な人物の紹介、算数から大学数学までの分かりやすい解説、数学の応用事例、日常の中で現れる数学、自分の数学研究の成果などが投稿されるプラットフォームでありたいです。"
      }), _jsx(_components.p, {
        children: "また、他のユーザが共有した魅力を発見できることも重要視しております。そのため、メインページや検索結果のページでは、多くの人から高評価されている魅力的な記事や本をより目立つ場所に表示します。その他にも、特定のカテゴリの記事や本を閲覧する機能、キーワードによる検索機能、タグに紐づく記事や本を閲覧できる機能、特定のユーザが投稿した記事や本を閲覧する機能を提供することで、数学の魅力の発見をサポートしています。"
      }), _jsx(_components.h3, {
        children: "アウトプットとフィードバックを通じた学び"
      }), _jsx(_components.p, {
        children: "Mathlog では、自分の知識や考えのアウトプットを通じた学びを大切にしております。自分が学んだことをアウトプットすることで、数学に対する理解がより深まることもあるからです。そのため、Mathlog は初心者でもアウトプットをできるプラットフォームでありたいです。"
      }), _jsx(_components.p, {
        children: "また、コメント欄によるフィードバックも重要視しています。初心者を含む誰もが投稿できるプラットフォームである以上、間違った内容が投稿されてしまうこともあると思います。運営は間違った記事や本であったとしても、間違っていることを理由に記事や本を削除することはしません。間違った記事や本でもコメント欄を通じたフィードバックで改善する仕組みを構築し、コミュニティ全体で記事や本の価値を高めていくことを目指しています。"
      }), _jsx(_components.h2, {
        children: "Mathlog で投稿可能な内容"
      }), _jsx(_components.p, {
        children: "Mathlog では、他の数学を学んでいる人を助ける内容、新たな数学の魅力に気づくきっかけになる内容、数学の学習を目的としたアウトプットの投稿を受け付けております。具体的には、以下に示した内容は投稿可能です。"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "小学校から大学までの算数および数学の解説、議論、質問"
        }), "\n", _jsx(_components.li, {
          children: "歴史上の数学の人物の活躍や数学の歴史の解説"
        }), "\n", _jsx(_components.li, {
          children: "数学を使ったネタ、大喜利などのエンタメ"
        }), "\n", _jsx(_components.li, {
          children: "数学の勉強法や数学を効率的に学ぶための Tips"
        }), "\n", _jsx(_components.li, {
          children: "受験や数学オリンピックの体験記"
        }), "\n", _jsx(_components.li, {
          children: "数学に関するイベントの告知"
        }), "\n", _jsx(_components.li, {
          children: "自分が気づいた数学の魅力"
        }), "\n", _jsx(_components.li, {
          children: "自分自身の数学研究の記録"
        }), "\n", _jsx(_components.li, {
          children: "物理学やコンピュータサイエンス、経済学などの数学の応用先となる分野の内容*"
        }), "\n"]
      }), _jsx(_components.p, {
        children: "* 運営としては、物理やコンピューターサイエンスなどの数学を応用した内容によって、数学に対する見方が変わる人や数学を学ぶきっかけになる人も多くいると考えております。そのため、数学を応用した分野の内容も投稿可能としています。"
      }), _jsx(_components.h2, {
        children: "間違っている記事や本への対応"
      }), _jsx(_components.p, {
        children: "Mathlog の哲学で説明したように、運営は間違っている記事や本についても削除を行うことはしません。しかし、内容に間違いがある記事や本は、時に読者に誤解を与え、数学の魅力の発見を阻害してしまうことがあります。そのため、初心者がアウトプットを通じた学びを得られる一方で、数学の魅力の発見も阻害しない仕組みが必要となります。"
      }), _jsx(_components.p, {
        children: "Mathlog では、読者が記事や本の信憑性を判断できるようにするために、以下の仕組みを導入しています。"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "記事や本の著者が内容に自信が持てない場合に、初心者マークをつけることができる機能。初心者マークを付けた記事の冒頭には、初心者として投稿している旨が表示され、読者に伝わるようになっております。"
        }), "\n", _jsx(_components.li, {
          children: "高評価数および低評価数の表示。読者は記事や本の客観的な評価を確認することができます。"
        }), "\n", _jsx(_components.li, {
          children: "コメントによるフィードバック。Mathlog では低評価をする前に、コメント欄で優しく指摘することを推奨していますので、コメント欄も合わせて参考にして頂くことができます。また、コメントは記事や本の著者は、削除はできない仕様となっております。これによって、良質な指摘が記事や本の著者によって不当に削除されることがないようにしております。一方で、誹謗中傷に代表される悪質なコメントが投稿されることもあるので、記事や本の著者がコメントを非表示にする機能は提供しております。非表示に設定されたコメントは、閲覧者が必要に応じて表示して確認することは可能です。"
        }), "\n", _jsx(_components.li, {
          children: "Google の検索エンジンや Mathlog 内での表示で、間違いを多く含む記事や悪質な記事の露出を抑える仕組み。具体的には、ユーザからのフィードバック（低評価や通報）を基に、表示・非表示の制御および表示の優先度の変更を行なっております。一方で、間違っている記事や本を投稿している著者が、フィードバックされる機会が失われてしまうのは良くないと考えております。そのため、タイムラインの「すべて」のビューやユーザのプロフィールページでは、低評価が多い記事や本もすべて表示しております。"
        }), "\n"]
      }), _jsx(_components.h2, {
        children: "利用上のマナー"
      }), _jsx(_components.h3, {
        children: "記事や本の投稿について"
      }), _jsx(_components.h4, {
        children: "タイトルは具体的かつ的確に設定しよう"
      }), _jsx(_components.p, {
        children: "記事や本のタイトルは多くのユーザの目に入ります。タイトルを見て内容が推測できるように、具体的かつ的確にタイトルをつけましょう。特に、読者を煽るタイトルや特定の団体や個人を誹謗中傷するようなタイトル、含まれていない内容をタイトルにすることは控えましょう。"
      }), _jsx(_components.h4, {
        children: "カテゴリやタグは正確に設定しよう"
      }), _jsx(_components.p, {
        children: "カテゴリやタグは閲覧者が記事や本を探す上で非常に重要な情報になります。間違った情報を入力してしまうと、不適切な場所や利用者にあなたの記事や本が表示されてしまう場合がございます。複数のカテゴリに属す内容の場合は、どのカテゴリを閲覧している人に見てもらいたいかを軸にカテゴリを決めて貰えると助かります。"
      }), _jsx(_components.h4, {
        children: "他の利用者を傷つける表現は控えよう"
      }), _jsx(_components.p, {
        children: "投稿する前にこの文章を投稿して読者を傷つけることはないかをよく確認しましょう。あなたの何気ない一言で他者を傷つけている場合があります。以下のような内容は控えましょう。"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "特定の団体や個人に対する嫌味・煽り・悪口"
        }), "\n", _jsx(_components.li, {
          children: "初心者や理解していない人を見下す内容"
        }), "\n", _jsx(_components.li, {
          children: "引用元に対する敬意が不足している内容"
        }), "\n", _jsx(_components.li, {
          children: "特定の商品やサービスの購入を薦めるためだけの内容"
        }), "\n", _jsx(_components.li, {
          children: "他者のプライバシー、著作権、肖像権を侵害する内容"
        }), "\n"]
      }), _jsx(_components.h4, {
        children: "議論の前提を揃えよう"
      }), _jsx(_components.p, {
        children: "数学では、採用する定義や公理の違いなどで、閲覧者にあなたの意図や主張が正確に伝わらない場合があります。議論の前提が閲覧者と食い違わないように、必要に応じて定義や公理などを伝わりやすい形で明示しましょう。自分自身が独自で定義した概念がある場合は特に注意が必要です。過去に解説している記事や本がある場合は、参考文献で明示した上で本文で引用するのも効果的です。"
      }), _jsx(_components.h4, {
        children: "わからない部分は表明しよう"
      }), _jsx(_components.p, {
        children: "Mathlog は中高生を含む多くの方が閲覧しています。中には、まだ数学の知識が十分でなくて、内容の真偽が自分では判断できない人もいます。そうした方に間違った情報を提供することがないように、執筆時点で自信がない箇所やわからない箇所、定かではない箇所がある場合は、本文の中で明示してあげましょう。有識者にコメントで意見を募るのも効果的です。また、Mathlog には初心者として投稿する機能もご用意していますので、そちらも合わせてご活用いただけますと幸いです。"
      }), _jsx(_components.h4, {
        children: "文章として成立していないメモの投稿は控えよう"
      }), _jsx(_components.p, {
        children: "Mathlog に投稿する文章は、多くの人が閲覧します。あなたにしか分らない個人的なメモを投稿するのはやめましょう。メモを投稿する場合も、他の人から見られても問題ない形式に整理してから投稿しましょう。"
      }), _jsx(_components.h4, {
        children: "問題には解答をつけよう"
      }), _jsx(_components.p, {
        children: "問題を考えたのにも関わらず、解答がないと読者が困ってしまいます。解答が既に分かっている場合は、なるべく問題だけではなく解答も添えて投稿しましょう。"
      }), _jsx(_components.h4, {
        children: "参考文献は明示しよう"
      }), _jsx(_components.p, {
        children: "Mathlog は誰でも記事や本を投稿できるという特性上、記事や本に誤っている内容が含まれてしまうことがあります。あなた自身が、参考にした情報の内容を誤解していたり、間違ったことを書いてしまうこともあると思います。そういった状況でも、他の閲覧者が元の情報にアクセスできるように、参考文献は可能な範囲で明示しましょう。"
      }), _jsx(_components.h3, {
        children: "コメントと返信の投稿"
      }), _jsx(_components.h4, {
        children: "相手への感謝の気持ちを忘れない"
      }), _jsx(_components.p, {
        children: "あなたの記事や本にコメントをしたり、あなたのコメントに返信をしてくれる人は日々の忙しい時間を割いて、あなたの文章を読んでくれています。その点に関して、相手への感謝の気持ちを忘れてはいけません。感謝の気持ちを本文に添えて投稿すると、文章でもお互いが気持ちよく意見交換できます。"
      }), _jsx(_components.h4, {
        children: "指摘する時は優しく丁寧に"
      }), _jsx(_components.p, {
        children: "ネットでの発言は相手の表情が読み取れないので、言葉が強くなりがちです。特に、理解している人から理解が十分でない人への指摘は注意が必要です。指摘する側にとっては、論理的に淡々と指摘をしただけのつもりでも、指摘を受け取る側にとっては高圧的に見えてしまうことがあります。相手に誤解を与えないような表現をすることも重要ですが、相手の感情にも配慮して可能な限り丁寧な言葉遣いをすることも重要です。記事や本の著者に感謝されるような指摘を目指しましょう。"
      }), _jsx(_components.h4, {
        children: "厳しい指摘をする人を感情的に悪人と決めつけない"
      }), _jsx(_components.p, {
        children: "自分が一生懸命書いた文章の根本から間違いを指摘された時に悲しい気持ちになってしまうのは理解できます。中には、一生懸命記事や本を書いた気持ちに同情・共感することなく、内容に関する高度な指摘のみをたくさん送ってくる人もいると思います。また、指摘する側が丁寧な言葉遣いを心がけていたとしても、投稿者であるあなたにとっては辛いこともあると思います。"
      }), _jsx(_components.p, {
        children: "しかし、そのような厳しい指摘をしてくる人を感情的にすぐに悪人と決めつけてはいけません（誹謗中傷や煽り、嫌味の場合は例外です）。少し時間をおいて冷静になってから、少しずつ対応していきましょう。理解が追いつかなくて修正できない場合は、素直に難しくてできないことを指摘者に伝えて、修正案を聞いてみましょう。"
      }), _jsx(_components.h4, {
        children: "謙虚さを忘れない"
      }), _jsx(_components.p, {
        children: "学問を学ぶものは常に「謙虚さ」を忘れてはいけません。自分の理解が合っていると思っている場合でも、常に相手の意見や論理を聞く余地を残しておくことは重要です。聞く余地が残されていないと、仮にあなたが間違っている場合に、間違いを受け入れることが難しくなってしまいます。これはあなたが数学を今後学んでいく上で、大きなマイナスになります。そのため、自分が間違っているかもしれないということを常に念頭に置きながら、コメントや返信をするようにしましょう。"
      }), _jsx(_components.h4, {
        children: "誹謗中傷・煽り・嫌味は控えよう"
      }), _jsx(_components.p, {
        children: "自分の発言は意見や批評で、誹謗中傷や煽り、嫌味とは違うから関係ないと思っていませんか。誹謗中傷、煽り、嫌味を含む発言をしている人のほとんどが同じように自分は例外だと思っています。「相手を困らせたり、不快感を与える目的で余計なひと言を足していない」と心の底から自信を持って言えますか。正論や批評のように見える歪んだ論理を振りかざして、相手が言い返せないように不快感を与えようとしていませんか。"
      }), _jsx(_components.p, {
        children: "例えば、十分に理解していない著者に対して、「ここから話さないとダメそうなので」という前置きを加えたり、理由に検討がついているにも関わらず、相手に実力不足を認めさせる目的で「なぜこんなことも直せないのですか」と付け加えたりしていませんか。相手へのおすすめという論理を盾に、「そんなことも分からないなら小学生からやり直した方がいい」などと発言していませんか。公益性ということを盾に、記事や本に無関係な投稿者に関する情報を暴露していませんか。"
      }), _jsx(_components.p, {
        children: "こうした相手に不快感を与えるような発言は、本質的ではない対立を生むだけで、問題解決には繋がりません。無意識のうちに書いた文章が相手に不快感を与える場合もあります。常に、投稿前に不快感を与える内容は含まれていないかを確認するようにしましょう。"
      }), _jsx(_components.h4, {
        children: "記事や本に関係ない内容は控えよう"
      }), _jsx(_components.p, {
        children: "Mathlog のコメント欄は記事や本の内容に関する感想、質問、議論、指摘を行う場所です。記事や本の内容と直接関係のないコメントや返信を投稿するのは控えましょう。"
      }), _jsx(_components.h4, {
        children: "外部メディアや SNS での煽動は控えよう"
      }), _jsx(_components.p, {
        children: "Mathlog のコメント欄の内容をスクショして、外部のメディアや SNS で煽動するのは控えましょう。建設的な意見を集める目的やポジティブな感情を共有する目的で投稿するのは問題ありませんが、コメントや返信をした人に対するネガティブな内容を投稿するのは好ましくありません。実際のコメント欄を見ていない人が、コメントや返信をした人に対して間違った印象を抱いてしまう場合もあります。悪質なユーザによるコメントや返信の場合も、外部の SNS で共有するのではなく、非表示にしたり、運営に通報したり、低評価をして無視しましょう。"
      }), _jsx(_components.h4, {
        children: "仕返しは控えよう"
      }), _jsx(_components.p, {
        children: "コメントや返信をしてくる人の中には、コミュニティガイドラインを守っていない人や規約違反をしている人がいることもあります。そうした時は、低評価機能や運営への通報機能を使ってフィードバックしてください。そして、その人に仕返しはせずに無視をしましょう。無視をするための機能として、コメント欄での非表示機能やコメントや返信の通知をミュートする機能を提供しています。返信をする場合も、あなた自身は違反を起こさないように対応しましょう。運営は仕返し目的の違反も特別視せずに違反として扱います。"
      }), _jsx(_components.h3, {
        children: "評価と通報について"
      }), _jsx(_components.h4, {
        children: "内容を読む前に評価や通報をするのは控えよう"
      }), _jsx(_components.p, {
        children: "Mathlog の評価システムおよび通報システムは、内容を読んだ上での利用を想定しております。適切にコンテンツの質や問題点を判断するためにも、ご協力のほどよろしくお願いします。"
      }), _jsx(_components.h4, {
        children: "低評価をする前に著者に優しく指摘しよう"
      }), _jsx(_components.p, {
        children: "Mathlog では、間違っているコンテンツも読者のフィードバックを通じて改善していくことを目指しています。そのため、低評価を行う前に著者に優しく指摘して改善を促しましょう。低評価は投稿者が指摘をしているにも関わらず、誠実な対応をしてくれない場合や改善を促したが建設的な議論が困難だった場合に使用して頂けますと幸いです。"
      }), _jsx(_components.h4, {
        children: "複数アカウントでの評価や通報は控えよう"
      }), _jsx(_components.p, {
        children: "複数のアカウントで特定の記事や本、コメント、返信を何回も評価したり通報することは控えましょう。Mathlog では、運営からの特別な許諾がない場合は、複数のアカウントの利用は禁止しております。また、運営は複数のアカウントを作成していることを検知するシステムで監視しています。悪質な場合は全てのアカウントを停止する場合もありますのでご了承ください。公平な評価システムと健全な通報システムを維持するためにも、ご協力いただけますと幸いです。"
      }), _jsx(_components.h2, {
        children: "違反に対する運営の対応"
      }), _jsx(_components.p, {
        children: "運営は、コミュニティガイドラインに違反している人に対して、ユーザの通報等を基に対応しております。具体的には、違反の程度に応じて、警告、一部機能の利用制限、アカウントの停止などを行なっております。お問い合わせでの運営の対応の催促はお返事しかねますので、あらかじめご了承ください。"
      }), _jsx(_components.p, {
        children: "運営は、Mathlog が目指す世界「数学の魅力の共有と発見」と「アウトプットとフィードバックを通じた学び」を実現するために、コミュニティの運営方針について日々検討や対応を行なっております。本来はコミュニティガイドラインの違反者にも、違反している点を改めて頂き、Mathlog の目指したい世界を実現する協力者になってもらいたいと考えております。"
      }), _jsx(_components.p, {
        children: "しかしながら、運営の限られたリソースの中で、コミュニティガイドラインの違反者の全員を説得することは現実的ではない状況もあります。そのため、運営の警告を無視している場合や重大な違反を行なっている場合は、コミュニティを守るために厳しい対応を行うことは避けられません。"
      }), _jsx(_components.p, {
        children: "数学コミュニティの所属者一人一人のモラルやマナーに対する意識が今後の Mathlog コミュニティの発展につながります。何卒、よろしくお願い致します。"
      }), _jsxs(_components.p, {
        children: ["制定日：2023 年 12 月 2 日", _jsx("br", {})]
      })]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
